export const GAO_FANG = `[
    {
        "name": "脉景养心膏",
        "uuid": "656e002e-c25f-4a36-bd13-054e40e32f7e",
        "medicines": [
            {
                "name": "炙甘草",
                "weight": 3
            },
            {
                "name": "党参",
                "weight": 5
            },
            {
                "name": "麦冬",
                "weight": 6.5
            },
            {
                "name": "生地黄",
                "weight": 6.5
            },
            {
                "name": "阿胶",
                "weight": 3
            },
            {
                "name": "肉桂",
                "weight": 3
            },
            {
                "name": "生姜",
                "weight": 3
            },
            {
                "name": "火麻仁",
                "weight": 3
            },
            {
                "name": "大枣",
                "weight": 5
            },
            {
                "name": "桂枝",
                "weight": 5
            },
            {
                "name": "茯苓",
                "weight": 6.5
            },
            {
                "name": "赤芍",
                "weight": 6.5
            },
            {
                "name": "桃仁",
                "weight": 5
            },
            {
                "name": "牡丹皮",
                "weight": 6.5
            },
            {
                "name": "饴糖",
                "weight": 40
            },
            {
                "name": "蜂蜜",
                "weight": 20
            }
        ]
    },
    {
        "name": "脉景宁肺膏",
        "uuid": "1bcfca12-90fb-4fe6-9697-f709fda3d8bd",
        "medicines": [
            {
                "name": "枳实",
                "weight": 5
            },
            {
                "name": "桔梗",
                "weight": 5
            },
            {
                "name": "当归",
                "weight": 6.5
            },
            {
                "name": "陈皮",
                "weight": 6.5
            },
            {
                "name": "生甘草",
                "weight": 3
            },
            {
                "name": "浙贝母",
                "weight": 6.5
            },
            {
                "name": "砂仁",
                "weight": 5
            },
            {
                "name": "木香",
                "weight": 5
            },
            {
                "name": "茯苓",
                "weight": 6.5
            },
            {
                "name": "栀子",
                "weight": 3
            },
            {
                "name": "瓜蒌仁",
                "weight": 5
            },
            {
                "name": "黄芩",
                "weight": 5
            },
            {
                "name": "生姜",
                "weight": 3
            },
            {
                "name": "竹茹",
                "weight": 6.5
            },
            {
                "name": "阿胶",
                "weight": 3
            },
            {
                "name": "饴糖",
                "weight": 40
            },
            {
                "name": "蜂蜜",
                "weight": 20
            }
        ]
    },
    {
        "name": "脉景壮儿膏",
        "uuid": "a246378c-663d-4751-a118-c5c0644ddce4",
        "medicines": [
            {
                "name": "山药",
                "weight": "15"
            },
            {
                "name": "党参",
                "weight": 5
            },
            {
                "name": "生白术",
                "weight": 6.5
            },
            {
                "name": "茯苓",
                "weight": 6.5
            },
            {
                "name": "当归",
                "weight": 6.5
            },
            {
                "name": "川芎",
                "weight": 6.5
            },
            {
                "name": "生白芍",
                "weight": 6.5
            },
            {
                "name": "熟地黄",
                "weight": 6.5
            },
            {
                "name": "阿胶",
                "weight": 3
            },
            {
                "name": "桂枝",
                "weight": 5
            },
            {
                "name": "麦冬",
                "weight": 6.5
            },
            {
                "name": "柴胡",
                "weight": 5
            },
            {
                "name": "防风",
                "weight": 5
            },
            {
                "name": "苦杏仁",
                "weight": 3
            },
            {
                "name": "桔梗",
                "weight": 5
            },
            {
                "name": "干姜",
                "weight": 3
            },
            {
                "name": "大枣",
                "weight": 5
            },
            {
                "name": "生甘草",
                "weight": 3
            },
            {
                "name": "白蔹",
                "weight": 3
            },
            {
                "name": "饴糖",
                "weight": 40
            },
            {
                "name": "蜂蜜",
                "weight": 20
            }
        ]
    },
    {
        "name": "脉景玉容膏",
        "uuid": "db73688d-1047-47b6-bf53-4eddc5f8cb3d",
        "medicines": [
            {
                "name": "吴茱萸",
                "weight": 3
            },
            {
                "name": "党参",
                "weight": 5
            },
            {
                "name": "麦冬",
                "weight": 6.5
            },
            {
                "name": "姜半夏",
                "weight": 5
            },
            {
                "name": "桂枝",
                "weight": 5
            },
            {
                "name": "生白芍",
                "weight": 6.5
            },
            {
                "name": "当归",
                "weight": 6.5
            },
            {
                "name": "川芎",
                "weight": 5
            },
            {
                "name": "牡丹皮",
                "weight": 6.5
            },
            {
                "name": "阿胶",
                "weight": 3
            },
            {
                "name": "生姜",
                "weight": 3
            },
            {
                "name": "生甘草",
                "weight": 3
            },
            {
                "name": "熟地",
                "weight": 6.5
            },
            {
                "name": "饴糖",
                "weight": 40
            },
            {
                "name": "蜂蜜",
                "weight": 20
            }
        ]
    },
    {
        "name": "脉景启阳膏",
        "uuid": "9b5727eb-a554-4bd8-899b-175cd2ae7748",
        "medicines": [
            {
                "name": "熟地",
                "weight": 6.5
            },
            {
                "name": "山药",
                "weight": "15"
            },
            {
                "name": "山茱萸",
                "weight": 6.5
            },
            {
                "name": "丹皮",
                "weight": 6.5
            },
            {
                "name": "泽泻",
                "weight": 6.5
            },
            {
                "name": "茯苓",
                "weight": 6.5
            },
            {
                "name": "柴胡",
                "weight": 5
            },
            {
                "name": "枳壳",
                "weight": 5
            },
            {
                "name": "生白芍",
                "weight": 6.5
            },
            {
                "name": "生甘草",
                "weight": 3
            },
            {
                "name": "黑顺片",
                "weight": 2
            },
            {
                "name": "干姜",
                "weight": 3
            },
            {
                "name": "淫羊藿",
                "weight": 6.5
            },
            {
                "name": "饴糖",
                "weight": 40
            },
            {
                "name": "蜂蜜",
                "weight": 20
            }
        ]
    }
]`;


// WEBPACK FOOTER //
// ./src/constants/Gaofang.ts